import _ from 'underscore';

export const getUserCountryService = ({ state, i18n }) => {
  if (!state || !i18n) {
    return {};
  }
  const countryCodes = ['AL', 'AQ', 'DZ', 'AS', 'AD', 'AO', 'AG', 'AR', 'AU', 'AT', 'BS', 'BD', 'BB', 'BE', 'BM', 'BT', 'BO', 'BW', 'BR', 'BZ', 'SB', 'VG', 'BN', 'BG', 'MM', 'BI', 'BY', 'KH', 'CM', 'CA', 'CV', 'KY', 'CF', 'LK', 'TD', 'CL', 'CN', 'TW', 'CX', 'CC', 'CO', 'YT', 'CG', 'CD', 'CK', 'CR', 'HR', 'CZ', 'BJ', 'DK', 'DM', 'DO', 'EC', 'SV', 'GQ', 'ET', 'ER', 'EE', 'FO', 'FK', 'FI', 'FR', 'GF', 'PF', 'DJ', 'GA', 'GM', 'DE', 'GH', 'GI', 'KI', 'GR', 'GL', 'GD', 'GP', 'GU', 'GT', 'GN', 'GY', 'HT', 'VA', 'HN', 'HU', 'IS', 'IN', 'ID', 'IE', 'IT', 'CI', 'JM', 'JP', 'KZ', 'KE', 'KR', 'KG', 'LA', 'LS', 'LV', 'LR', 'LY', 'LI', 'LT', 'LU', 'MG', 'MW', 'MY', 'MV', 'ML', 'MT', 'MQ', 'MR', 'MU', 'MX', 'MC', 'MN', 'MD', 'MS', 'MA', 'MZ', 'NA', 'NR', 'NP', 'NL', 'AN', 'AW', 'NC', 'VU', 'NZ', 'NI', 'NE', 'NG', 'NF', 'NO', 'MP', 'FM', 'MH', 'PW', 'PK', 'PA', 'PG', 'PY', 'PE', 'PH', 'PN', 'PL', 'PT', 'GW', 'PR', 'RE', 'RU', 'RW', 'AI', 'SM', 'ST', 'SN', 'SC', 'SL', 'SG', 'SK', 'VN', 'SI', 'ZA', 'ZW', 'ES', 'SR', 'SZ', 'SE', 'CH', 'TJ', 'TH', 'TG', 'TK', 'TO', 'TT', 'TR', 'TM', 'TC', 'UG', 'MK', 'EG', 'GB', 'TZ', 'US', 'BF', 'UY', 'UZ', 'WF', 'WS', 'ZM', 'BA', 'FJ', 'HK', 'MO', 'VE', 'AZ', 'BH', 'AM', 'CY', 'GE', 'IL', 'JO', 'KW', 'LB', 'OM', 'QA', 'SA', 'AE', 'YE', 'PS', 'AF', 'TL', 'NU', 'RO', 'SO', 'KM', 'TN', 'IQ', 'SH', 'KN', 'LC', 'PM', 'VC', 'TV', 'UA', 'VI', 'RS', 'ME'];

  const getCountriesAndSetState = () => {
    if (state.get('userCountries')) {
      return;
    }

    const countries = _.map(countryCodes, code => ({
      Key: code,
      Value: i18n.getString(`UserCountry_${code}`) || code,
    })).sort((a, b) => ((a.Value > b.Value) ? 1 : -1));

    state.set('userCountries', countries);
  };

  const userCountryService = {
    getCountriesAndSetState,
  };

  return {
    userCountryService,
  };
};
